/* eslint-disable jsx-a11y/anchor-is-valid */
/*
 * --------------------------------------
 * Copyright (c) 2020 BetterCapital.US
 * --------------------------------------
 */
import React, { PureComponent } from "react";
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  Badge
} from "reactstrap";
import AddAsset from "../Dashboard/AddAsset";
import { withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import { getAssetStyleClass, getAssetTypeLabel } from "../../helpers";

class AssetImportButton extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      investment_type: null,
      showImportModal: false,
      user_role: null,
      import_steps: []
    };
  }

  getUserRoleForInvestmentType = investment_type => {
    switch (investment_type) {
      case "note":
      case "syndication":
      case "fund":
        return "I";
      case "rental":
      case "flip":
      case "primary":
      default:
        return "O";
    }
  };
  toggleImportModal = investment_type => {
    this.setState(prevState => ({
      showImportModal: !prevState.showImportModal,
      investment_type: investment_type,
      user_role: this.getUserRoleForInvestmentType(investment_type),
      import_steps: this.stepsByInvestmentType(investment_type)
    }));
  };

  onAddAsset = slug => {
    this.toggleImportModal();
    this.props.history.push(`/assets/${slug}`);
  };

  stepsByInvestmentType = investment_type => {
    switch (investment_type) {
      case "note":
        return [
          {
            label: "Summary",
            number: "1"
          },
          {
            label: "Investment",
            number: "2"
          }
        ];
      case "syndication":
      case "fund":
        return [
          {
            label: "Investment",
            number: "1"
          }
        ];
      default:
        return [
          {
            label: "Summary",
            number: "1"
          },
          {
            label: "Investment",
            number: "2"
          },
          {
            label: "Financials",
            number: "3"
          }
        ];
    }
  };

  render() {
    return (
      <>
        {this.props.asCard ? (
          <a
            href="#/"
            onClick={() => this.toggleImportModal(this.props.assetType)}
            className="addproparty-item"
          >
            <div className="add-proparty">
              <div className="addproparty-details">
                <div className="add-proparty-cion">
                  <img src="assets/images/home-placeholder.png" alt="" />
                </div>
                <div className="add-proparty-message">
                  <h4>Add your asset</h4>
                  <p>
                    <Badge
                      className="p-2 h-auto font-size-md"
                      color={getAssetStyleClass(this.props.assetType)}
                    >
                      {getAssetTypeLabel(this.props.assetType)}
                    </Badge>
                  </p>
                </div>
              </div>
              <div className="addproparty-plus">
                <img src="assets/images/plus.png" alt="" />
              </div>
            </div>
          </a>
        ) : (
          <UncontrolledDropdown tag="span" className="m-2">
            <DropdownToggle color="primary" caret>
              <span className="btn-wrapper--label">Add Asset</span>
            </DropdownToggle>
            <DropdownMenu>
              <div role="menuitem">
                <a
                  className="dropdown-item"
                  href="#/"
                  onClick={() => this.toggleImportModal("rental")}
                >
                  Rental
                </a>
              </div>
              <div role="menuitem">
                <a
                  className="dropdown-item"
                  href="#/"
                  onClick={() => this.toggleImportModal("note")}
                >
                  Private Lending
                </a>
              </div>
              <div role="menuitem">
                <a
                  className="dropdown-item"
                  href="#/"
                  onClick={() => this.toggleImportModal("syndication")}
                >
                  Syndication
                </a>
              </div>
              <div role="menuitem">
                <a
                  className="dropdown-item"
                  href="#/"
                  onClick={() => this.toggleImportModal("primary")}
                >
                  Primary
                </a>
              </div>
              {/* <div role="menuitem">
                <a
                  className="dropdown-item"
                  href="#/"
                  onClick={() => this.toggleImportModal("fund")}
                >
                  Fund
                </a>
              </div>*/}
            </DropdownMenu>
          </UncontrolledDropdown>
        )}
        <AddAsset
          showModal={this.state.showImportModal}
          toggleModal={this.toggleImportModal}
          onAddAsset={this.onAddAsset}
          user_role={this.state.user_role}
          investment_type={this.state.investment_type}
          import_steps={this.state.import_steps}
        />
      </>
    );
  }
}

AssetImportButton.propTypes = {
  asCard: PropTypes.bool,
  assetType: PropTypes.string
};

AssetImportButton.defaultProps = {
  asCard: false,
  assetType: "rental"
};

export default withRouter(AssetImportButton);
